import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import type {
  CreditReportDocument,
  CreditReportSummaryPayload,
  CreditSubscriptionPayload,
} from './credit-overview.model';

export interface CreditOverviewApi {
  /** GET /credit/status */
  getStatus(guid: string): Observable<CreditSubscriptionPayload>;
  /** GET /credit/report/summary */
  getReportSummary(guid: string): Observable<CreditReportSummaryPayload>;
  /** GET /credit/report — PDF response decoded as a browser Blob. */
  getReport(guid: string): Observable<CreditReportDocument>;
  /** POST /credit/invite — sends the active client a repeatable Intercom invite. */
  inviteClient(guid: string): Observable<void>;
}

export const CREDIT_OVERVIEW_API = new InjectionToken<CreditOverviewApi>(
  'CREDIT_OVERVIEW_API',
);
